const formStyles = {
  formContainer: {
    maxWidth: "600px",
    margin: "auto",
    padding: "2rem",
    background: "#fff",
    borderRadius: "8px",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    display: "flex",
    flexDirection: "column",
  },
  heading: {
    fontSize: "1.8rem",
    fontWeight: "bold",
    color: "#333",
    marginBottom: "1.5rem",
    textAlign: "center",
  },
  label: {
    fontSize: "1rem",
    color: "#555",
    marginBottom: "0.5rem",
  },
  inputField: {
    padding: "0.8rem",
    fontSize: "1rem",
    marginBottom: "1.2rem",
    border: "1px solid #ccc",
    borderRadius: "4px",
    backgroundColor: "#f9f9f9",
  },
  textareaField: {
    padding: "0.8rem",
    fontSize: "1rem",
    marginBottom: "1.2rem",
    border: "1px solid #ccc",
    borderRadius: "4px",
    backgroundColor: "#f9f9f9",
    minHeight: "120px",
  },
  submitButton: {
    backgroundColor: "#4CAF50",
    color: "#fff",
    fontSize: "1rem",
    fontWeight: "bold",
    padding: "1rem",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    transition: "background-color 0.3s ease",
  },
};

export default formStyles;
